
import Meta from "../../components/custom-ui/meta/Meta";
import { requireAuth } from "../../providers/auth";
import EventManagement from "./EventManagement_Refinement";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch } from "react-instantsearch-hooks-web";

const searchClient = (() => {
  if (!process.env.REACT_APP_ALGOLIA_APP_ID) {
    throw new Error(
      "REACT_APP_ALGOLIA_APP_ID environment variable not defined",
    );
  }
  if (!process.env.REACT_APP_ALGOLIA_API_KEY) {
    throw new Error(
      "REACT_APP_ALGOLIA_API_KEY environment variable not defined",
    );
  }

  return algoliasearch(
    process.env.REACT_APP_ALGOLIA_APP_ID,
    process.env.REACT_APP_ALGOLIA_API_KEY,
  );
})();

function EventManagement_InstantSearch() {
  return (
    <div className="pt-36 min-h-screen">
      <InstantSearch searchClient={searchClient} indexName={"Events-Queries"}>
        <Meta title="Events" />
        <EventManagement />
      </InstantSearch>
     
    </div>
  );
}
export default requireAuth(EventManagement_InstantSearch);
